module.exports = __webpack_public_path__ + "assets/loop-account.49567c1e.svg";